module.exports = __webpack_public_path__ + "08d20675c9a19195443b76291f4a6b58.jpg";